import { memo } from "react";

import SetUp from "@/components/ui/icon/set-up";

const SETUP_MANUAL_URL = "https://chillnn.notion.site/CHILLNN-Manual-4f45718809404c289ad8238c884b0e7e";
const VIDEO_MANUAL_URL = "https://chillnn.notion.site/311fffe15c578048a90ee8261864677f";

export const Manual = memo(() => {
	return (
		<div className="space-y-4">
			<div>
				<p>CHILLNNを使いはじめるために必要な初期設定や</p>
				<p>スムーズに導入するためのステップをまとめたマニュアル集</p>
			</div>

			<div className="flex flex-wrap gap-x-4 gap-y-2">
				<a
					href={SETUP_MANUAL_URL}
					target="_blank"
					className="inline-flex gap-x-2 rounded border border-zinc-200 p-4 hover:bg-zinc-100"
				>
					<SetUp />
					セットアップマニュアル
				</a>

				<a
					href={VIDEO_MANUAL_URL}
					target="_blank"
					className="inline-flex gap-x-2 rounded border border-zinc-200 p-4 hover:bg-zinc-100"
				>
					<SetUp />
					動画マニュアル
				</a>
			</div>
		</div>
	);
});

Manual.displayName = "Manual";
